import { DefaultRouteBuilder } from '../../route/route.builder';
import { Route, RouteBuilderOptions } from '../../route/route.types';

class DirectConnectRouteBuilder extends DefaultRouteBuilder {
  constructor() {
    super({
      prefix: Route.DIRECT_CONNECT,
    });
  }

  public getMachineRoute(
    _teamId: string,
    machineId: string,
    options?: RouteBuilderOptions | undefined
  ): string {
    return this.build(`machine/${machineId}`, options);
  }

  public getMachineDetailsRoute(
    _teamId: string,
    machineId: string,
    options?: RouteBuilderOptions
  ): string {
    return this.build(`machine/${machineId}/details`, options);
  }

  public getMachineScratchpadRoute(
    _teamId: string,
    machineId: string,
    scratchpadId: string,
    options?: RouteBuilderOptions
  ): string {
    return this.build(
      `machine/${machineId}/scratchpad/${scratchpadId}`,
      options
    );
  }
}

export { DirectConnectRouteBuilder };
